export var TranslationsKeys;
(function (TranslationsKeys) {
    TranslationsKeys["FORM_TITLE"] = "smtp.formTitle";
    TranslationsKeys["TITLE"] = "smtp.title";
    TranslationsKeys["SUBTITLE"] = "smtp.form.subtitle";
    TranslationsKeys["MESSAGE_API_FAILURE"] = "smtp.message.apiFailure";
    TranslationsKeys["MESSAGE_SAVE_FAILURE"] = "smtp.message.saveFailure";
    TranslationsKeys["SAVE_BUTTON"] = "smtp.actions.save";
    TranslationsKeys["EDIT_BUTTON"] = "smtp.actions.edit";
    TranslationsKeys["CONFIGURE_BUTTON"] = "smtp.actions.configure";
    TranslationsKeys["DELETE_BUTTON"] = "smtp.actions.delete";
    TranslationsKeys["TOAST_SUCCESS"] = "tscli.ui.datasave.success.message";
    TranslationsKeys["DELETE_SUCCESS"] = "smtp.delete.success";
})(TranslationsKeys || (TranslationsKeys = {}));
//# sourceMappingURL=constants.js.map